import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Toast } from "../../../../../components/Toast";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import Input from "../../../../../components/Input";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import StyledDialog from "../../../../../components/StyledDialog";
import { useEffect } from "react";

interface ConfirmationModalProps {
  toast?: Toast | null;
  closeToast?: () => void;
  isLoading?: boolean;
  onConfirm: (values: any) => void;
  disclosureHost: DisclosureHost;
  inputLabel?: string;
  prefillName?: string;
}

const CopyFormModal = ({
  isLoading,
  onConfirm,
  disclosureHost,
  inputLabel,
  prefillName,
}: ConfirmationModalProps) => {
  const formik = useFormik({
    initialValues: { name: prefillName ?? "" },
    validationSchema: Yup.object({
      name: Yup.string()
        .trim()
        .required()
        .label(inputLabel || ""),
    }),
    onSubmit: (values) => onConfirm(values.name),
  });

  useEffect(() => {
    formik.setFieldValue("name", prefillName ? prefillName + "-copy" : "");
  }, [prefillName, disclosureHost.opened]);

  return (
    <StyledDialog
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      dialogTitle="Make a Copy"
      dialogAction={
        <Button variant="contained" onClick={formik.submitForm} autoFocus>
          Make Copy
        </Button>
      }
    >
      <LoadingOverlay isLoading={!!isLoading} />

      <Box width={"30vw"}>
        <Input
          required
          label={inputLabel}
          textFieldProps={{
            name: "name",
            value: formik.values?.name,
            onBlur: formik.handleBlur,
            onChange: formik.handleChange,
            placeholder: "Enter Name",
          }}
          error={formik.touched?.name && formik.errors?.name}
        />
      </Box>
    </StyledDialog>
  );
};

export default CopyFormModal;
